export default __webpack_public_path__ + "static/1f4274cd-2674-481e-9023-69e33ffca161-c5390f94cb3a504dd851059242696ff5.woff2";